import { ListResponse } from '../../goodstack'

import { InfiniteQueryFn } from '@percent/workplace-giving/common/hooks/useQuery/useQuery.types'
import { Organisation, SearchOrganisationQuery } from './searchOrganisations.types'

export const searchOrganisations: InfiniteQueryFn<
  [string, SearchOrganisationQuery],
  string,
  ListResponse<Organisation>
> = async (client, [_, { query = '', pageSize = 25, countryCode, excludeCountryCodes }], cursor) =>
  (
    await (cursor
      ? client.get<ListResponse<Organisation>>(cursor, {
          withCredentials: true
        })
      : client.get<ListResponse<Organisation>>(`v1/organisations`, {
          params: {
            query,
            pageSize,
            ...(countryCode && { countryCode }),
            ...(excludeCountryCodes && { excludeCountryCodes })
          },
          withCredentials: true
        }))
  ).data
